/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type AddressesPage_viewer$ref = any;
export type queries_AddressesPage_QueryVariables = {};
export type queries_AddressesPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": AddressesPage_viewer$ref;
    }) | null;
};
export type queries_AddressesPage_Query = {
    readonly response: queries_AddressesPage_QueryResponse;
    readonly variables: queries_AddressesPage_QueryVariables;
};



/*
query queries_AddressesPage_Query {
  viewer {
    id
    ...AddressesPage_viewer
  }
}

fragment AddressesPage_viewer on Viewer {
  id
  user {
    id
    role
    ...AccountAddressBook_user
    ...AccountAddAddressDialog_user
    shippingAddressDefault {
      addressId
      addressLineOne
      addressLineTwo
      city
      country
      firstName
      lastName
      nickname
      phoneNumber
      recipientBirthDate
      specialInstructions
      state
      street
      zip
      id
    }
  }
}

fragment AccountAddressBook_user on User {
  id
  addressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
  shippingAddressBook {
    totalNumberOfAddresses
    entries(first: 100) {
      edges {
        node {
          id
          address {
            id
            ...AddressBookItem_address
            addressId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
  }
}

fragment AccountAddAddressDialog_user on User {
  id
  shippingAddressDefault {
    id
    addressId
    lastName
    firstName
    street
    addressLineOne
    addressLineTwo
    city
    state
    zip
    phoneNumber
  }
  shippingAddressIdDefault
  addressBook {
    id
    entries(first: 100) {
      edges {
        node {
          id
          address {
            ...AddressBookItem_address
            addressId
            lastName
            firstName
            street
            addressLineOne
            addressLineTwo
            city
            state
            zip
            phoneNumber
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  shippingAddressBook {
    id
  }
}

fragment AddressBookItem_address on Address {
  ...AddressBookItemText_address
  ...AddressBookItemTextMobile_address
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment AddressBookItemText_address on Address {
  id
  addressId
  ...AddressBookItemStreet_address
  ...AddressBookItemName_address
}

fragment AddressBookItemTextMobile_address on Address {
  addressId
  addressLineOne
  addressLineTwo
  city
  companyName
  country
  firstName
  id
  lastName
  specialInstructions
  phoneNumber
  recipientBirthDate
  state
  zip
  nickname
}

fragment AddressBookItemStreet_address on Address {
  id
  addressId
  addressLineOne
  addressLineTwo
  city
  state
  zip
}

fragment AddressBookItemName_address on Address {
  nickname
  companyName
  firstName
  lastName
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfAddresses",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 100,
            "type": "Int"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "companyName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineOne",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLineTwo",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nickname",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "addressId",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "specialInstructions",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "phoneNumber",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "recipientBirthDate",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "street",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_AddressesPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "AddressesPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_AddressesPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "addressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:100)",
                                            "args": (v2 /*: any*/),
                                            "concreteType": "AddressBookEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AddressBookEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AddressBookEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "address",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Address",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/)
                                                                    ]
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        },
                                                        (v19 /*: any*/)
                                                    ]
                                                },
                                                (v20 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v2 /*: any*/),
                                            "handle": "connection",
                                            "key": "AddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressBook",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AddressBook",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:100)",
                                            "args": (v2 /*: any*/),
                                            "concreteType": "AddressBookEntryConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AddressBookEntryEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AddressBookEntry",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "address",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Address",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v0 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/),
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/)
                                                                    ]
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        },
                                                        (v19 /*: any*/)
                                                    ]
                                                },
                                                (v20 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v2 /*: any*/),
                                            "handle": "connection",
                                            "key": "ShippingAddressBook_entries",
                                            "filters": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingAddressDefault",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Address",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v0 /*: any*/),
                                        (v12 /*: any*/),
                                        (v11 /*: any*/),
                                        (v17 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v10 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v15 /*: any*/),
                                        (v13 /*: any*/),
                                        (v9 /*: any*/),
                                        (v16 /*: any*/),
                                        (v14 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shippingAddressIdDefault",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_AddressesPage_Query",
            "id": null,
            "text": "query queries_AddressesPage_Query {\n  viewer {\n    id\n    ...AddressesPage_viewer\n  }\n}\n\nfragment AddressesPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n    ...AccountAddressBook_user\n    ...AccountAddAddressDialog_user\n    shippingAddressDefault {\n      addressId\n      addressLineOne\n      addressLineTwo\n      city\n      country\n      firstName\n      lastName\n      nickname\n      phoneNumber\n      recipientBirthDate\n      specialInstructions\n      state\n      street\n      zip\n      id\n    }\n  }\n}\n\nfragment AccountAddressBook_user on User {\n  id\n  addressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  shippingAddressBook {\n    totalNumberOfAddresses\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            id\n            ...AddressBookItem_address\n            addressId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AccountAddAddressDialog_user on User {\n  id\n  shippingAddressDefault {\n    id\n    addressId\n    lastName\n    firstName\n    street\n    addressLineOne\n    addressLineTwo\n    city\n    state\n    zip\n    phoneNumber\n  }\n  shippingAddressIdDefault\n  addressBook {\n    id\n    entries(first: 100) {\n      edges {\n        node {\n          id\n          address {\n            ...AddressBookItem_address\n            addressId\n            lastName\n            firstName\n            street\n            addressLineOne\n            addressLineTwo\n            city\n            state\n            zip\n            phoneNumber\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  shippingAddressBook {\n    id\n  }\n}\n\nfragment AddressBookItem_address on Address {\n  ...AddressBookItemText_address\n  ...AddressBookItemTextMobile_address\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment AddressBookItemText_address on Address {\n  id\n  addressId\n  ...AddressBookItemStreet_address\n  ...AddressBookItemName_address\n}\n\nfragment AddressBookItemTextMobile_address on Address {\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  companyName\n  country\n  firstName\n  id\n  lastName\n  specialInstructions\n  phoneNumber\n  recipientBirthDate\n  state\n  zip\n  nickname\n}\n\nfragment AddressBookItemStreet_address on Address {\n  id\n  addressId\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  zip\n}\n\nfragment AddressBookItemName_address on Address {\n  nickname\n  companyName\n  firstName\n  lastName\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '418f49d0ffbb437fee6c0187437b8249';
export default node;
